// extracted by mini-css-extract-plugin
export default {"topMenu":"b5c4a7caa33e2640f9a9","link":"c1457b9150b70ee090ed"};